// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"ccd34592","6452":"e33c496b","6850":"6baad0a8","6942":"2169c1a8","9337":"ccd34592"}[chunkId] + ".chunk.css";
};